
import { PropType, StyleValue } from 'vue'

import toggleArrayItemMixin from '@/mixins/toggleArrayItemMixin'

import Plant from '@/models/Plant'
import Garden from '@/models/Garden'

import SvgShape from '@/ui/components/gardens/SvgShape.vue'
import PlantAvatar from '@/ui/components/plants/PlantAvatar.vue'

import { id } from '@/types/models'

export default toggleArrayItemMixin.extend({
  components: {
    SvgShape,
    PlantAvatar,
  },
  // mixins: [toggleArrayItemMixin],
  props: {
    value: {
      type: Array as PropType<id[]>,
      default: (): id[] => [],
    },
    garden: Object as PropType<Garden>,
    // plants: Array as PropType<Plant[]>,
    id: String,
    maxHeight: {
      type: [Number, String],
      default: undefined,
    },
  },
  data: () => ({
    //
  }),
  computed: {
    plants(): Array<Plant> {
      // return this.$store.getters['plants/plantsInGarden'](this.garden.id)
      return this.garden.plants.filter((p) => p.isActive)
    },
    uprootedPlants(): Array<Plant> {
      return this.garden.plants.filter((p) => !p.isActive)
    },
    selectedPlantIds(): id[] {
      return this.value
    },
    plantsWithAvatar(): Plant[] {
      return this.plants.filter((p: Plant) => p.hasAvatar)
    },
    svgStyle(): StyleValue {
      return {
        'max-height': this.maxHeight
          ? isNaN(Number(this.maxHeight))
            ? this.maxHeight
            : this.maxHeight + 'px'
          : undefined,
        margin: `1em auto`,
      }
    },
  },
  watch: {
    //
  },
  methods: {
    //
  },
  created() {
    //
  },
  mounted() {
    //
  },
})
